import axiosInstance from "./AxiosInstance";

export default {
    getToken(base64Credentials) {
        return axiosInstance({
            method: "get",
            url: "/auth/get",
            headers: {
                "Relay-Authorization": `Basic ${base64Credentials}`,
            },
        });
    },
    renewToken() {
        return axiosInstance({
            method: "get",
            url: "/auth/renew",
        });
    },
};
